module.exports = __webpack_public_path__ + "static/media/map_transparent_marker.ec8afa3d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/map_transparent_marker.svg
// module id = 514
// module chunks = 0